function cov_21dx94728n() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SquareFeetFilled.tsx";
  var hash = "d9eccd64eaedfb2f380d7da6d970b294a5de9c56";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SquareFeetFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 58
        },
        end: {
          line: 7,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d9eccd64eaedfb2f380d7da6d970b294a5de9c56"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_21dx94728n = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_21dx94728n();
var Icon = (cov_21dx94728n().s[0]++, {
  name: 'square-feet-filled',
  svg: "<path d=\"M3.25 9.14812V3.75C3.25 3.47386 3.47386 3.25 3.75 3.25H9.91928C10.381 3.25 10.596 3.82227 10.2485 4.12629L4.07925 9.52441C3.75596 9.80729 3.25 9.5777 3.25 9.14812Z\" fill=\"currentColor\"/>\n  <path d=\"M20.75 14.8519V20.25C20.75 20.5261 20.5261 20.75 20.25 20.75H14.0807C13.619 20.75 13.404 20.1777 13.7515 19.8737L19.9207 14.4756C20.244 14.1927 20.75 14.4223 20.75 14.8519Z\" fill=\"currentColor\"/>\n  <path d=\"M20.75 3.75V9.14812C20.75 9.5777 20.244 9.80729 19.9207 9.52441L13.7515 4.12629C13.404 3.82227 13.619 3.25 14.0807 3.25H20.25C20.5261 3.25 20.75 3.47386 20.75 3.75Z\" fill=\"currentColor\"/>\n  <path d=\"M3.25 14.8519V20.25C3.25 20.5261 3.47386 20.75 3.75 20.75H9.91928C10.381 20.75 10.596 20.1777 10.2485 19.8737L4.07925 14.4756C3.75596 14.1927 3.25 14.4223 3.25 14.8519Z\" fill=\"currentColor\"/>"
});
export default Icon;